// src/features/rooms/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import ExcelDownloadPage from './pages/ExcelTemplatePage';
import StaffParserPage from './pages/StaffParserPage';

export const SetupRoutes = () => (
  <Route path="setup">
    <Route
      path="download"
      element={
        <ProtectedRoute requiredScope="staff:create">
          <ExcelDownloadPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="parse"
      element={
        <ProtectedRoute requiredScope="staff:create">
          <StaffParserPage />
        </ProtectedRoute>
      }
    />
  </Route>
);